import CrmLayout from '@/layouts/crm'

export default [
  {
    name: 'crm',
    path: '/',
    redirect: '/download',
    component: CrmLayout,
    children: [
      {
        name: 'download',
        path: '/download',
        component: () => import('_crm/download'),
        meta: {
          title: '立林家服APP'
        }
      },
      {
        name: 'crmAgreement',
        path: '/agreement/v1.0',
        component: () => import('_crm/agreement/V1.0'),
        meta: {
          title: '用户协议及隐私政策'
        }
      },
      {
        name: 'crmServe',
        path: '/serve/v1.0',
        component: () => import('_crm/agreement/ServeV1.0'),
        meta: {
          title: '立林家服用户服务协议'
        }
      },
      {
        name: 'crmIntimate',
        path: '/intimate/v1.0',
        component: () => import('_crm/agreement/IntimateV1.0'),
        meta: {
          title: '立林家服隐私政策'
        }
      },
      {
        name: 'crmProcessDetail',
        path: '/process/detail/:type/:id',
        component: () => import('_crm/process'),
        meta: {
          title: '流程'
        }
      },
      {
        name: 'crmLogisticsDetail',
        path: '/logistics/detail/:orderNo/:logisticsNo',
        component: () => import('_crm/logistics'),
        meta: {
          title: '物流详情'
        }
      },
      {
        name: 'messageDetail',
        path: '/message/detail',
        beforeEnter: ({ query }, from, next) => {
          const pathObj = { 0: '/notice/detail' }
          next(pathObj[query.mesType] ? { path: pathObj[query.mesType], query } : '404')
        }
      },
      {
        name: 'noticeDetail',
        path: '/notice/detail',
        component: () => import('_crm/notice'),
        meta: {
          title: '公告详情'
        }
      }
    ]
  }
]
